import { imageFieldNames, iframeFieldNames, linkFieldNames } from '../constants/field-names';

const mapFieldNamesToValues = (fieldNames, valuesArray) =>
  Object.fromEntries(fieldNames.map((fieldName, index) => [fieldName, valuesArray[index]]));

const getFieldsValues = (fieldNames, getValues) => {
  const allRelatedFieldNames = Object.values(fieldNames);
  const allRelatedValuesArray = getValues(allRelatedFieldNames);

  return mapFieldNamesToValues(allRelatedFieldNames, allRelatedValuesArray);
};

const getLinkFieldsValues = (getValues) => getFieldsValues(linkFieldNames, getValues);

const getImageFieldsValues = (getValues) => getFieldsValues(imageFieldNames, getValues);

const getIframeFieldsValues = (getValues) => getFieldsValues(iframeFieldNames, getValues);

export { getLinkFieldsValues, getImageFieldsValues, getIframeFieldsValues };
